import { create } from "zustand";
import { retrieveSettings, updateSettings as updateSettingsRequest, testConnection, TestConnectionResponse } from "./actions";

export type SettingsData = {
    status?: string;
    host?: string;
    hosts: string[];
};

export type SettingsUpdatePayload = {
    key?: Blob;
    hosts: string[];
};

type SettingProps = {
    settingsData?: SettingsData | null;
    updateSettings: (val: SettingsUpdatePayload) => Promise<string>;
    retriveSettings: () => Promise<number>;
    testConn: (host: string) => Promise<TestConnectionResponse>;
};

export const normalizeHosts = (payload: any): string[] => {
    const seen = new Set<string>();
    const result: string[] = [];
    const push = (value: unknown) => {
        if (typeof value !== "string") return;
        const trimmed = value.trim();
        if (!trimmed || seen.has(trimmed)) return;
        seen.add(trimmed);
        result.push(trimmed);
    };

    if (Array.isArray(payload?.hosts)) {
        payload.hosts.forEach(push);
    } else if (typeof payload?.host === "string") {
        push(payload.host);
    }

    return result;
};

export const useSettings = create<SettingProps>((set, get) => ({
    settingsData: null,
    async updateSettings(val) {
        const current = get().settingsData ?? { hosts: [], host: undefined, status: undefined };
        const nextHosts = Array.isArray(val.hosts) ? val.hosts : [];
        const activeHost = nextHosts.length > 0 ? nextHosts[0] : undefined;
        set({
            settingsData: {
                ...current,
                hosts: nextHosts,
                host: activeHost,
            },
        });
        return updateSettingsRequest(val.key, nextHosts);
    },
    async retriveSettings() {
        if (get().settingsData !== null) return 200;
        const res = await retrieveSettings();
        if (res.Code === 200) {
            const hosts = normalizeHosts(res.Msg);
            const activeHost = hosts.length > 0 ? hosts[0] : undefined;
            set({
                settingsData: {
                    status: res.Msg?.status,
                    hosts,
                    host: activeHost,
                },
            });
        }
        return res.Code;
    },
    async testConn(host) {
        return testConnection(host);
    },
}));
